'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const ClientTeaserOnPageContext = /*#__PURE__*/ React.createContext(undefined);
const ClientTeaserOnPageUpdator = /*#__PURE__*/ React.createContext(undefined);
export function ClientTeaserOnPageProvider({ children }) {
    const [clientTeaserOnPage, setClientTeaserOnPage] = React.useState(new Set());
    const teaserOnPageActions = React.useMemo(()=>({
            getExcludeString (serverTeaserIds) {
                return [
                    ...clientTeaserOnPage,
                    ...serverTeaserIds ? [
                        serverTeaserIds
                    ] : []
                ].toString();
            }
        }), [
        clientTeaserOnPage
    ]);
    const teaserOnPageUpdators = React.useMemo(()=>({
            addClientTeasers: (teaserIds)=>{
                setClientTeaserOnPage((prev)=>new Set([
                        ...prev,
                        ...teaserIds
                    ]));
            },
            clearClientTeasers: ()=>{
                setClientTeaserOnPage(new Set());
            }
        }), []);
    return /*#__PURE__*/ _jsx(ClientTeaserOnPageContext, {
        value: teaserOnPageActions,
        children: /*#__PURE__*/ _jsx(ClientTeaserOnPageUpdator, {
            value: teaserOnPageUpdators,
            children: children
        })
    });
}
export default function useGettersClientTeasersOnPage() {
    const context = React.use(ClientTeaserOnPageContext);
    if (context === undefined) {
        throw new Error('useGettersClientTeasersOnPage must be used within a ClientTeaserOnPageProvider');
    }
    return context;
}
export function useMutatorsClientTeasersOnPage() {
    const context = React.use(ClientTeaserOnPageUpdator);
    if (context === undefined) {
        throw new Error('useMutatorsClientTeasersOnPage must be used within a ClientTeaserOnPageProvider');
    }
    return context;
}
export function useClientTeasersOnPageAtom() {
    return [
        useGettersClientTeasersOnPage(),
        useMutatorsClientTeasersOnPage()
    ];
}

//# sourceMappingURL=clientTeasersOnPageAtom.js.map